<template>
  <div id="carouselExampleCaptions" class="carousel slide slideshow-container">
    <div class="carousel-inner">
      <a
        v-for="(slide, key) in slideShow"
        :key="key"
        :href="getUrl(slide.url)"
        class="carousel-item"
        data-bs-interval="2800"
        :class="{'active': key === 0}"
      >
        <img :src="slide.imageSrc" class="d-block w-100 image" :alt="slide.altTag">
        <div class="carousel-caption h-100 d-flex flex-column justify-content-center">
          <span
            class="slider-title"
            :class="{'long-title': slide.name.length > 20 && slide.name.length <= 50, 'very-long-title': slide.name.length > 50}"
            v-text="slide.name"
          />
          <div class="slider-desc" v-text="slide.desc" />
          <div class="row d-flex justify-content-center align-items-center gap-3">
            <div v-for="(badge, index) in slide.badges" :key="index" class="search-result-badge">
              <div class="search-result-badge-text" v-text="badge.value" />
              <i class="bi bi-x-lg search-result-badge-icon" @click="onCancelBadge($event, badge.name)" />
            </div>
          </div>
          <CustomButton
            v-if="slide.buttonLink !== null"
            class="d-flex justify-content-center slider-btn"
            :title="slide.buttonTitle"
            :link="slide.buttonLink"
          />
        </div>
      </a>
    </div>
    <button
      v-if="slideShow.length > 1"
      class="carousel-control-prev"
      type="button"
      data-bs-target="#carouselExampleCaptions"
      data-bs-slide="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true" />
    </button>
    <button
      v-if="slideShow.length > 1"
      class="carousel-control-next"
      type="button"
      data-bs-target="#carouselExampleCaptions"
      data-bs-slide="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import CustomButton from '@/components/custom-button/CustomButton.vue'
import { Carousel } from 'bootstrap'

export default {
  name: 'SliderShow',
  components: {
    CustomButton,
  },
  props: {
    slideShow: {
      type: Object,
      required: true,
    },
  },
  emits: ['cancelBadge'],
  mounted() {
    // lapozó beállítása initkor.
    const myCarouselElement = document.querySelector('#carouselExampleCaptions')

    // eslint-disable-next-line no-new
    new Carousel(myCarouselElement, {
      interval: 5000,
    }).cycle()
  },
  methods: {
    /**
     * Badge kikapcsolás kezelő.
     *
     * @param event
     * @param name
     */
    onCancelBadge(event, name) {
      this.$emit('cancelBadge', name)
      // Mivel körülötte van egy link, ezért annak az eventjért nem akarjuk ilyenkor hivni.
      event.preventDefault()
    },
    /**
     * Url kiszámolása, az alapján, hogy külső vagy belső.
     * @param {string|null} link
     * @return {*}
     */
    getUrl(link) {
      // amikor nincs link akkor nem tudnunk hova navigálni.
      // tud null lenni, amikor nem adjuk meg, hogy van nagiváljon a slide
      if (link === null) {
        return null
      }
      if (link.includes(window.location.origin)) {
        return link.replace(window.location.origin, '')
      }
      return link
    },
  },
}

</script>

<style scoped lang="scss">
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins/breakpoints';

.carousel-caption {
  gap: 1.25rem;
  padding-bottom: 0;
}

.carousel .carousel-indicators button {
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 100%;
  margin: 0 0.313rem;
}

.image {
  max-height: 25rem;
  min-height: 25rem;
  object-fit: cover;
}

.slider-title {
  font-family: Montserrat, serif;
  font-weight: 500;
  font-size: 3.125rem;
  line-height: 4.5rem;
  display: flex;
  justify-content: center;
  position: relative;
  transition: transform 0.3s ease-in-out;
  text-shadow: 0.25rem 0.25rem 0.25rem rgba(0, 0, 0, 0.65);
  hyphens: auto; // kötőjelet rak a tördelt szórész végére - kell, hogy a html lang be legyen állítva lehetőleg magyarra.
}

.search-result-badge {
  display: flex;
  background-color: #DFDFDF;
  border-radius: 0.25rem;
  padding: 0.3125rem;
  width: fit-content;
}

.search-result-badge-text {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.0625rem;
  letter-spacing: 0.02em;
  text-align: center;
  color: #303030;
  padding: 0 0.625rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
  white-space: nowrap;
}

.search-result-badge-icon {
  color: #303030;
  cursor: pointer;
}

@include media-breakpoint-down(md) {
  .slider-title {
    font-size: 2.75rem;
  }
}

@include media-breakpoint-down(sm) {
  .long-title {
    font-size: 2rem;
    line-height: 3.5rem;
  }

  .very-long-title {
    font-size: 1.5rem;
    line-height: 3rem;
  }
}

.slider-desc {
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.688rem;
  text-shadow: 0.25rem 0.25rem 0.25rem rgba(0,0,0,0.65);
  hyphens: auto; // kötőjelet rak a tördelt szórész végére - kell, hogy a html lang be legyen állítva lehetőleg magyarra.
}

.slider-btn {
  :deep(.custom-btn) {
    height: 2.0625rem;
    align-items: center;
  }
}
</style>
